// extracted by mini-css-extract-plugin
export default {"ErrorLogo":"Error_ErrorLogo__EoDWh","ErrorMessage":"Error_ErrorMessage__v4OwJ"};